// to and next will be passed as context variable, the store is needed to check if the person is logged in.

export default function auth({ to, next, store }) {
  const loginQuery = { path: "/login", query: { redirect: to.fullPath } };
  if (!store.getters["user/isAuthenticated"]) {
    store.dispatch("user/fetchUser").then(() => {
      if (!store.getters["user/isAuthenticated"]) next(loginQuery);
      else next();
    });
  } else {
    next();
  }
}
